export const ROUTES = {
  LOGIN: "/login",
  LOGIN_ADMIN: "/login/admin",
  DASHBOARD: "/dashboard",
  CANDIDATES: "/candidates",
  CANDIDATE_PROFILE: "/candidates/:id",
  CANDIDATE_EDIT: "/candidates/:id/edit",
  DEGREE: "/degree",
  INDUSTRY: "/industry",
  TEAM: "/team",
  DEPARTMENT: "/department",
  CATEGORY: "/category",
  SKILL: "/skill",
  MASTER_MANAGEMENT: "/master-management",
  MY_PROFILE: "/profile",
  RESUMES: "/resumes",
  TEMPLATES: "/templates",
} as const;
